/* unplugin-vue-components disabled */import { render } from "./AISpeachGeneratorPanelOption.vue?vue&type=template&id=6af5c2d6&scoped=true&ts=true"
import script from "./AISpeachGeneratorPanelOption.vue?vue&type=script&lang=ts"
export * from "./AISpeachGeneratorPanelOption.vue?vue&type=script&lang=ts"

import "./AISpeachGeneratorPanelOption.vue?vue&type=style&index=0&id=6af5c2d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6af5c2d6"]])

export default __exports__